export default __webpack_public_path__ + "static/media/facebook.e8ae7e42.svg";